const Controller = {
  dynamoDB: "api/api/ocufiidynamodb",
  Email: "api/api/Email",
  Sponsor: "api/api/Sponsor",
};

export default Controller;
